var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.repaired.length > 0)?_c('WorkCardRepaired',{attrs:{"data":_vm.repaired}}):_c('h4',{staticClass:"mensaje"},[_vm._v("No tienes trabajos reparados por ahora.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }